<template>
	<div
		class="bg-primary w-screen h-screen flex items-center justify-center main"
		:style="{
			backgroundImage: `url(${driveUrl}/apps/theming/image/background)`
		}"
	>
		<form @submit="submit">
			<div class="text-white text-center rounded-sm box-login">
				<img
					class="mx-auto mb-3"
					:src="assetsUrl + '/logo-light.svg'"
					width="150px"
					:alt="brand"
				/>
				<p class="mb-3">
					<span class="font-thin">{{ $t('bienvenido') }}</span>
					{{ brand }} XCloud
				</p>
				<div>
					<input
						v-model="email"
						class="input-login p-2 w-100"
						type="email"
						v-bind:placeholder="$t('email')"
					/>
					<div v-if="$v.email.$dirty" class="text-left">
						<div class="font-12 text-red-500 mt-1" v-if="!$v.email.required">
							* {{ $t('email_requerido') }}
						</div>
						<div class="font-12 text-red-500 mt-1" v-if="!$v.email.email">
							* {{ $t('email_invalido') }}
						</div>
					</div>
				</div>
				<div>
					<input
						v-model="password"
						class="input-login p-2 mt-2 w-100"
						type="password"
						v-bind:placeholder="$t('password')"
					/>
					<div v-if="$v.password.$dirty" class="text-left">
						<div class="font-12 text-red-500 mt-1" v-if="!$v.password.required">
							* {{ $t('password_requerida') }}
						</div>
						<div
							class="font-12 text-red-500 mt-1"
							v-if="!$v.password.minLength"
						>
							* {{ $t('password_invalid') }}
						</div>
					</div>
				</div>
				<button
					class="
						w-100
						bg-white
						text-primary
						border-0
						rounded-full
						p-2
						mt-4
						shadow-md
						outline-none
						cursor-pointer
						hover:text-primary
						focus:outline-none
					"
				>
					<span
						class="font-bold"
						v-if="loginStatus == null || loginStatus == 'ERROR'"
						>{{ $t('Entrar') }}</span
					>
					<span v-if="loginStatus == 'PENDING'">{{ $t('entrando') }}...</span>
				</button>

				<div class="my-4">
					<router-link to="/password_recovery">
						{{ $t('forgot_password') }}
					</router-link>
				</div>
				<div v-if="loginStatus == 'ERROR'">
					<!-- TODO: se tendria que especificar si el usuario no existe o si la contraseña no es correcta
                            También se tendrá que implementar el "recordar contraseña" -->
					<p>
						{{ $t('server_error') }}
					</p>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			brand: process.env.VUE_APP_BRAND,
			assetsUrl: process.env.VUE_APP_ASSETS_URL,
			driveUrl: process.env.VUE_APP_DRIVE_URL,
			email: '',
			password: '',
			error: false
		}
	},
	watch: {
		email: function (newValue) {
			this.email = newValue.toLowerCase()
		}
	},
	validations: {
		email: {
			required,
			email
		},
		password: {
			required,
			minLength: minLength(8)
		}
	},
	computed: {
		...mapGetters({
			loginStatus: 'login/loginStatus'
		})
	},
	methods: {
		submit(e) {
			e.preventDefault()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.$store.dispatch('login/login', {
					email: this.email.toLowerCase(),
					password: this.password
				})
			}
		}
	}
}
</script>
<style scoped>
.main {
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
}
.box-login {
	padding: 3rem;
	width: 400px;
}
.w-100 {
	width: 100%;
}
.input-login {
	border-color: transparent;
	background: rgba(255, 255, 255, 0.15);
	color: #fff;
	border-radius: 5px;
}

::placeholder {
	color: #fff;
}

.input-login:focus {
	-webkit-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
	box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
}
.font-12 {
	font-size: 12px;
}
</style>
